import { call, put } from 'redux-saga/effects';
import { handleServerError } from 'store/alerts/actions';
import { fetchWithdrawalStatusApi } from 'store/giftCards/api';
import { setValue } from 'store/giftCards/actions';

function* fetchWithdrawalStatus() {
  try {
    const { data } = yield call(fetchWithdrawalStatusApi);

    yield put(setValue({ waitingConfirmation: data?.state === 'WAITING_CONFIRMATION' }));
  } catch (error) {
    yield put(handleServerError(error));
    yield put(setValue({ waitingConfirmation: false }));
  }
}

export default fetchWithdrawalStatus;
